<template>
    <Form ref="info" :model="info" :label-width="100">
        <Row :gutter="20">
            <Col span="24">
                <FormItem label="轮播图片" prop="title">
                    <preview-upload v-model="info.advertising"
                        multiple :readonly="readonly"
                        thumbNails="128x128"
                        @on-delete="onDelete"
                        @on-upload="onUpload">
                    </preview-upload>
                </FormItem>
            </Col>
        </Row>
    </Form>
</template>
<script>
import PreviewUpload from '_c/preview-upload'
import { fileDelete, fileUpdate, queryBySource } from '@/api/sys-oss'

export default {
    data() {
        return {
            loading: false,
            info: {
                advertising: ''
            },
            sourceType: 'notify_carousel',
        }
    },
    components: { PreviewUpload },

    computed: {
        readonly() {
            return this.loading || !this.$can('update')
        },
    },

    created() {
        this.fetch()
    },

    methods: {
        fetch() {
            let body = {
                sourceType: this.sourceType
            }
            this.loading = true

            queryBySource(body)
                .then(res => {
                    this.info.advertising = JSON.stringify(res.data.list)
                })
                .finally(() => (this.loading = false))
        },

        onDelete(file) {
            this.loading = true

            fileDelete(file.id)
                .then(res => {
                    this.$Message.success(this.$t('tips.delete.success'))
                })
                .finally(() => (this.loading = false))
        },

        onUpload(file) {
            let body = {
                id: file.id,
                sourceType: this.sourceType
            }

            this.loading = true
            fileUpdate(body)
                .then(res => {
                    this.$Message.success(this.$t('tips.add.success'))
                })
                .finally(() => (this.loading = false))
        },
    }
}
</script>